import type { BackendRouteDefinition } from '../types';

export const getAllEmployeesWithAuthInfoRoute = {
  transport: 'api',
  method: 'GET',
  path: '/firms/employees',
} as const satisfies BackendRouteDefinition;
